export default __webpack_public_path__ + "static/media/icon_1.7f2a5aff.svg";